import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Solutions } from './components/Solutions';
import { Services } from './components/Services';
import { ValuesBand } from './components/ValuesBand';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/WhatsAppLink';
import AdminPanel from './components/AdminPanel';
import { AdminAccess } from './components/AdminAccess';

// Main Website Component
const MainWebsite = () => {
  return (
    <>
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <About />
        <Solutions />
        <Services />
        <ValuesBand />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainWebsite />} />
        <Route path="/admin" element={<AdminAccess>{props => <AdminPanel {...props} />}</AdminAccess>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;